import axios from 'utils/axios';

export const checkEmailRegistrationCode = (code: string) => {
  return axios.get(`/api/v1/registration/codes/${code}`);
};
